// Returns a job's Apollo URL only if it is safe to use as a link, else null.
//
// Users submit this URL with every job and admins open it to fulfil manual
// jobs. The server now rejects anything but a real apollo.io People-search
// link (backend/utils/apollo_url.py), but jobs saved before that check may
// hold anything - including a javascript: URL, which React still renders into
// href. This mirrors the server rule so old records cannot become live links.
export function safeApolloHref(url) {
  if (typeof url !== 'string') return null;
  const trimmed = url.trim();
  // Backslashes are read as "/" by browsers and can change the host;
  // whitespace and control characters never appear in a copied URL.
  // eslint-disable-next-line no-control-regex
  if (!trimmed || /[\s\\\u0000-\u001f\u007f<>"`]/.test(trimmed)) return null;

  let parsed;
  try {
    parsed = new URL(trimmed);
  } catch (e) {
    return null;
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null;
  if (parsed.username || parsed.password) return null;

  const host = parsed.hostname.toLowerCase().replace(/\.$/, '');
  if (host !== 'apollo.io' && !host.endsWith('.apollo.io')) return null;

  return parsed.href;
}

export default safeApolloHref;
